﻿import type {ProjectMapRequest} from "../models/project-map-request.model";
import type {RouteEditorGate} from "../models/route-editor-gate.model";
import type { RouteEditorRoute } from "../models/route-editor-route.model";

export function parseProjectMapRequestFromCsv(csv: string): ProjectMapRequest {
    const projectMap: ProjectMapRequest = {
        routes: [],
        gates: []
    }
    
    // Ignore 1st header line 
    const dateRows = csv.split('\n').slice(1).filter(line => line.trim() !== '');

    dateRows.forEach(row => {
        try{
            if(lineDescribesGate(row)) {
                projectMap.gates.push(parseGateFromCsvRow(row));
            }
            else {
                // We assume that gates are higher up in the CSV than routes
                projectMap.routes.push(parseRouteFromCsvRow(row, projectMap.gates));
            }
        }
        catch(e) {
            console.log('Failed to parse row: ' + row + '. Error: ' + e + '.');
            throw e;
        }
    });
    
    return projectMap;
}

function parseGateFromCsvRow(row: string): RouteEditorGate {
    const fields = row.split(',');
    if (fields.length < 3) {
        throw new Error(`Invalid line: "${row}"". Line must contain at least 3 fields. The import is aborted.`);
    }

    // Note: Fields in CSV are order x,y which is lon,lat instead of lat,lon.
    const lon = parseFloat(fields[0]);
    if (isNaN(lon)) throwCoordinateParsingError(row, lon, 'Longitude')
    
    const lat = parseFloat(fields[1]);
    if (isNaN(lat)) throwCoordinateParsingError(row, lat, 'Latitude')

    const gateName = fields[2];
    return { 
        id: null, 
        name: gateName, 
        latitude: lat, 
        longitude: lon 
    };
}

function throwCoordinateParsingError(row: string, value: any, coordinateName: string) {
    throw new Error(`Invalid line: "${row}". ${coordinateName} value "${value}" is not a valid floating point number. The import is aborted.`);
}

function parseRouteFromCsvRow(row: string, gates: RouteEditorGate[]): RouteEditorRoute {
    const fields = row.split(':');
    
    const routeName = fields[0];
    const gateNames = fields[1].split(',');
    
    gateNames.forEach(gateName => {
        const matchingGate = gates.find(x => x.name === gateName)
        if(!matchingGate) 
            throw new Error(`Gate ${gateName} was not found in the list of gates. The import is aborted.`);
    })
    
    return {
        id: null,
        name: routeName,
        gateNames: gateNames
    }
}

function lineDescribesGate(line: string) {
    return !line.includes(':')
}